var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListingIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17332E",
    fillRule: "evenodd",
    d: "M3.5 15a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm17 0a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3h11zm-17-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm17 0a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3h11zm-17-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm17 0a1.5 1.5 0 0 1 0 3h-11a1.5 1.5 0 0 1 0-3h11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingIconActive);
export default __webpack_public_path__ + "static/media/listing-icon-active.84a0d26c00958943db9e554c3ddc86ba.svg";
export { ForwardRef as ReactComponent };